<template>
  <div class="send-tokens-modal">
    <FullBackdrop class="fenif-test">
      <div class="container spinner" v-if="sendingLoading">
        <Spinner />
      </div>
      <div
        class="container"
        v-if="!notEnoughTokens && !sendingLoading"
      >
        <h3 class="modal-title">{{ $t("videocall.messages.title_extend_call", { tokens: videoCallRoom.tokens_per_extra_min }) }}</h3>
        <div class="form-input">
          <div
            style="
              margin-top: 1rem;
              font-weight: bold;
              text-transform: uppercase;
            "
          >
            Tokens Disponibles:
            <template v-if="balanceLoaded">{{ balance }}</template>
          </div>
        </div>

        <div class="footer">
          <button class="cancel active" @click="cancelHandler">
            {{ $t("tokens_modal.button_cancel") }}
          </button>
          <button @click="buyExtraMinute">
            {{ $t("tokens_modal.button_send") }}
          </button>
        </div>
      </div>
      <div class="container" v-if="notEnoughTokens">
        <h3 class="modal-title" style="color: red">
          {{ $t("tokens_modal.title_not_enough_tokens") }}
        </h3>
        <p
          style="
            font-weight: bold;
            font-size: 1.2rem;
            text-transform: uppercase;
          "
        >
          {{ $t("tokens_modal.description_not_enought_tokens") }}
        </p>
        <div class="footer">
          <button class="cancel active" @click="cancelHandler">
            {{ $t("tokens_modal.button_back") }}
          </button>
          <router-link class="action" :to="{ name: 'purchase.tokens' }">
            <button>{{ $t("tokens_modal.button_buy_tokens") }}</button>
          </router-link>
        </div>
      </div>
    </FullBackdrop>
  </div>
</template>

<script>
import FullBackdrop from "../../FullBackdrop";
import Spinner from "../../Spinner";

import resources from "../../../resources";

export default {
  components: {
    FullBackdrop,
    Spinner
  },
  props: {
    videoCallRoom: {
      required: true,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      notEnoughTokens: false,
      sendingLoading: false,
      tokensSended: false,
      balanceLoaded: false,
      balance: 0,
    };
  },
  methods: {
    buyExtraMinute() {
      this.sendingLoading = true;
      resources.videoCallRoom
        .storeAt({ id: this.$route.params.hash + "/buy_extra_minute" })
        .then((response) => {
          if (response.status != 200 || response.data.result != "ok") return;
          this.videoCallRoom.mins++;
          this.$emit("cancel");
        })
        .catch((error) => {
          if (error.status == 422) {
            // Here maybe I should redirect the user. or show an error message.
            console.log("VideoCallRoom does not exist");
            return;
          }
          console.log("error", error);
        }).finally(() => {
          this.sendingLoading = false;
        });
    },
    cancelHandler() {
      this.$emit("cancel");
      this.tokensSended = false;
    },
    getTokensBalance() {
      resources.tokensBalance.index({}).then((response) => {
        this.balance = response.data.data.balance;
        this.balanceLoaded = true;
      });
    },
  },
  mounted() {
    this.getTokensBalance();
  },
};
</script>

<style scoped lang="scss">
@import "../../../styles/variables";
@import "../../../styles/classes";

@import "../jisti.scss";

.send-tokens-modal {
  & .spinner {
    align-items: center;
    display: flex;
    min-width: 300px;
    min-height: 300px;
    justify-content: center;
  }

  & .container {
    box-sizing: border-box;
    border-radius: 1rem;
    border: solid 2px #ccc;
    padding: 1rem;

    @media (min-width: 768px) {
      min-width: 350px;
    }

    & .modal-title {
      font-size: 1.5rem;
      text-transform: uppercase;
    }

    & h3 {
      margin: 0.5rem 0;
    }

    & .form-input {
      margin: 0.5rem 0;

      & .error-message {
        color: var(--pallete_main_color);
        font-size: 0.9rem;
        padding: 0.3rem;
        margin: 0;
      }
    }

    & .footer {
      display: flex;
      justify-content: end;

      & button {
        @extend %secondary-btn;
      }

      & button,
      .action {
        border-radius: 0.5rem;
        margin-left: 1rem;
        font-size: 1rem;
        font-weight: bold;
        text-transform: uppercase;
        padding: 0.5rem 1rem;
      }

      & .action {
        padding: 0;
      }

      & .action > button {
        margin-left: 0;
      }

      & button.cancel {
        @extend %fresh-btn;

        border-radius: 0.5rem;
      }
    }

    & label {
      box-sizing: border-box;
      font-weight: bold;
      padding: 0 1rem 0 0;
    }

    & input {
      border: none;
      border-radius: 1rem;
      font-size: 1rem;
      padding: 0.3rem 0.5rem 0.8rem 0.5rem;
      width: 100%;
    }

    & input:focus {
      border: transparent;
      outline: none;
    }

    & fieldset {
      border-color: #ffffff7d;
      border-radius: 0.5rem;
      padding: 0;
      margin-top: 1.5rem;

      & legend {
        color: #767676;
        font-size: 1rem;
        margin-left: 0.3rem;
        font-weight: bold;
        text-transform: uppercase;
      }
    }

    & fieldset:has(> input:focus),
    & fieldset:has(> textarea:focus) {
      border-color: var(--pallete_main_color);
    }
  }

  & .success {
    text-align: center;

    & h3 {
      color: green;
    }

    & .picture {
      height: 6rem;
      width: 6rem;
    }

    & .cancel {
      font-size: 1.2rem;
      font-weight: bold;
    }

    & .footer {
      justify-content: center;
      margin-top: 1rem;
    }

    & .name {
      font-size: 1.2rem;
      text-transform: uppercase;
      padding: 0 0.5rem;
      font-weight: bold;
    }

    & .message_tokens {
      font-size: 1.5rem;
      font-weight: bold;
      margin: 1rem 0 0.5rem 0;
      text-transform: uppercase;
    }

    & .tokens_quantity {
      font-size: 2.5rem;
      color: red;
      font-weight: bold;
    }
  }
}
</style>
